<template>
  <b-modal :id="id" size="lg"
           ok-title="Закрыть" :ok-only="true" ok-variant="secondary" @ok="onClose">
    <template slot="modal-title">
      Импорт состава комплекта
    </template>

    <b-form @submit.prevent="onUpload" :disabled="loading">
      <b-form-group label="Комплект для обновления" v-if="! onlyReading">
        <set-search v-model="set" :set-id="this.setId"></set-search>
      </b-form-group>
      <b-form-row align-h="between">
          <div class="col-10">
            <b-form-group label="Файл с составом комплекта">

            <b-file v-model="uploadForm.file" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    browse-text="Выбрать" placeholder="Файл не выбран"></b-file>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group>
              <label>&nbsp;</label>
              <b-btn type="submit" variant="outline-primary" block :disabled="(! onlyReading && ! set) || ! uploadForm.file">
                <b-spinner small v-if="loading"></b-spinner>
                Загрузить
              </b-btn>
            </b-form-group>
          </div>
      </b-form-row>
    </b-form><br>
    <b-alert variant="success" :show="!loading && success">
      Состав комплекта успешно импортирован
    </b-alert>
    <b-alert variant="danger" :show="!loading && error">
      <h4>Ошибка при импорте</h4>
      <p>{{ errorMsg }}</p>
    </b-alert>
  </b-modal>
</template>

<script>

import SetSearch from '~/components/Set/SetSearch'
export default {
  name: 'SetComponentsImportModal',
  components: { SetSearch },
  props: {
    id: {
      type: String,
      required: true
    },
    setId: {
      validator: (val) => Number.isInteger(val) || val === null,
      default: null
    },
    onlyReading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      set: null,
      uploadForm: this.$inertia.form({
        file: null
      }),
      loading: false,
      success: false,
      error: false,
      errorMsg: null
    }
  },
  methods: {
    onUpload () {
      this.error = false
      this.success = false
      this.loading = true

      const data = new FormData()
      data.append('file', this.uploadForm.file)

      const route = this.onlyReading
        ? this.route('backend.sets.read-components')
        : this.route('backend.sets.import-components', this.set.id)

      window.axios
        .post(route, data, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(resp => {
          this.loading = false
          if (resp.data.status === 'OK') {
            this.success = true
            this.uploadForm.reset()
          }

          if (this.onlyReading) {
            this.$emit('read', resp.data.data)
          }
        })
        .catch(err => {
          if (err.response.data?.message) {
            this.errorMsg = err.response.data.message
          }
          this.loading = false
          this.error = true
        })
    },

    onClose () {
      if (this.success && !this.error) {
        this.$inertia.reload()
      }

      this.error = false
      this.success = false
    }
  }
}
</script>
